module.exports = {
  // Generic
  'generic.add': 'Adicionar',
  'generic.cancel': 'Cancelar',

  // BlockType
  'components.controls.blocktype.h1': 'H1',
  'components.controls.blocktype.h2': 'H2',
  'components.controls.blocktype.h3': 'H3',
  'components.controls.blocktype.h4': 'H4',
  'components.controls.blocktype.h5': 'H5',
  'components.controls.blocktype.h6': 'H6',
  'components.controls.blocktype.blockquote': 'Blockquote',
  'components.controls.blocktype.code': 'Código',
  'components.controls.blocktype.blocktype': 'Bloquear',
  'components.controls.blocktype.normal': 'Normal',

  // Color Picker
  'components.controls.colorpicker.colorpicker': 'Seletor de cores',
  'components.controls.colorpicker.text': 'Cor do texto',
  'components.controls.colorpicker.background': 'Cor de destaque',

  // Embedded
  'components.controls.embedded.embedded': 'Embedded',
  'components.controls.embedded.embeddedlink': 'Link Embedded',
  'components.controls.embedded.enterlink': 'Insira o link',

  // Emoji
  'components.controls.emoji.emoji': 'Emoji',

  // FontFamily
  'components.controls.fontfamily.fontfamily': 'Fonte',

  // FontSize
  'components.controls.fontsize.fontsize': 'Tamanho da fonte',

  // History
  'components.controls.history.history': 'Registro',
  'components.controls.history.undo': 'Desfazer',
  'components.controls.history.redo': 'Refazer',

  // Image
  'components.controls.image.image': 'Imagem',
  'components.controls.image.fileUpload': 'Upload de arquivo',
  'components.controls.image.byURL': 'URL',
  'components.controls.image.dropFileText':
    'Arraste o arquivo ou clique para fazer o upload',

  // Inline
  'components.controls.inline.bold': 'Negrito',
  'components.controls.inline.italic': 'Itálico',
  'components.controls.inline.underline': 'Sublinhar',
  'components.controls.inline.strikethrough': 'Tachar',
  'components.controls.inline.monospace': 'monospace',
  'components.controls.inline.superscript': 'Sobrescrito',
  'components.controls.inline.subscript': 'Subscrito',

  // Link
  'components.controls.link.linkTitle': 'Título do link',
  'components.controls.link.linkTarget': 'Endereço do link',
  'components.controls.link.linkTargetOption': 'Abra o link em uma nova janela',
  'components.controls.link.link': 'Inserir link',
  'components.controls.link.unlink': 'Remover link',

  // List
  'components.controls.list.list': 'Lista',
  'components.controls.list.unordered': 'Lista com marcadores',
  'components.controls.list.ordered': 'Lista numerada',
  'components.controls.list.indent': 'Aumentar recuo',
  'components.controls.list.outdent': 'Diminuir recuo',

  // Remove
  'components.controls.remove.remove': 'Remover',

  // TextAlign
  'components.controls.textalign.textalign': 'Alinhar o texto',
  'components.controls.textalign.left': 'Alinhar à esquerda',
  'components.controls.textalign.center': 'Alinhar no centro',
  'components.controls.textalign.right': 'Alinhar à direita',
  'components.controls.textalign.justify': 'Justificar'
};
